export default __webpack_public_path__ + "static/media/loading.a37f21f0.svg";